import { IconProps } from "@/src/sb/business-layer/types"

const Search = (props: IconProps) => (
  <svg
    width={props.width ?? props.size ?? 16}
    height={props.height ?? props.size ?? 16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.76337 13.5267C10.4987 13.5267 13.5267 10.4987 13.5267 6.76337C13.5267 3.02806 10.4987 0 6.76337 0C3.02806 0 0 3.02806 0 6.76337C0 10.4987 3.02806 13.5267 6.76337 13.5267ZM6.76337 12.625C10.0006 12.625 12.625 10.0006 12.625 6.76337C12.625 3.5261 10.0006 0.901782 6.76337 0.901782C3.5261 0.901782 0.901782 3.5261 0.901782 6.76337C0.901782 10.0006 3.5261 12.625 6.76337 12.625ZM14.8935 15.5312L12.3788 13.0164L12.042 12.6797C11.8659 12.5036 11.8659 12.2181 12.042 12.042C12.2181 11.8659 12.5036 11.8659 12.6797 12.042L13.0164 12.3788L15.5312 14.8935L15.8679 15.2303C16.044 15.4064 16.044 15.6919 15.8679 15.8679C15.6919 16.044 15.4064 16.044 15.2303 15.8679L14.8935 15.5312Z"
      fill={props.color ?? "currentColor"}
    />
  </svg>
)

export default Search
